import { useUIStore } from '@/config/stores/ui-store';
import { Reply } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { Message } from '../../models/message';

interface ReplyActionProps {
  message: Message;
}

export const ReplyAction: React.FC<ReplyActionProps> = ({ message }) => {
  const { t } = useTranslation();
  const setReplyMessage = useUIStore((state) => state.setReplyMessage);

  const handleReply = useCallback(() => {
    setReplyMessage(message.conversationId, message);
  }, [setReplyMessage, message]);

  return (
    <Tooltip title={t('messages.actions.reply')} placement='top'>
      <IconButton
        size='small'
        onClick={handleReply}
        sx={{
          width: { xs: 44, md: 28 },
          height: { xs: 44, md: 28 },
          minWidth: { xs: 44, md: 28 },
          minHeight: { xs: 44, md: 28 },
          backgroundColor: 'background.paper',
          color: 'text.primary',
          boxShadow: 1,
          '&:hover': {
            backgroundColor: 'action.hover',
            boxShadow: 2
          },
          '&:disabled': {
            color: 'text.disabled',
            backgroundColor: 'transparent'
          }
        }}
      >
        <Reply sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
};
